<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  gridClassName="feeds-grid"
  [paginated]="false"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
></app-data-grid>
